import { render, staticRenderFns } from "./DeleteCustomField.vue?vue&type=template&id=49fb09b8&"
import script from "./DeleteCustomField.vue?vue&type=script&lang=js&"
export * from "./DeleteCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports